import { colors } from '@/theme/colors';

type EngineIconProps = {
  size?: { width: number; height: number };
  fill?: string;
};

export default function EngineIcon({
  size = { width: 24, height: 24 },
  fill = colors.neutral10,
}: EngineIconProps) {
  return (
    <svg
      width={`${size.width}px`}
      height={`${size.height}px`}
      viewBox={`0 0 ${size.width} ${size.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 8.75C6.67903 8.75 6.85216 8.68596 6.98809 8.56944L8.45723 7.31019C8.50254 7.27135 8.56025 7.25 8.61992 7.25H11H13.5858C13.6521 7.25 13.7157 7.27634 13.7626 7.32322L14.2929 6.79289L13.7626 7.32322L15.4697 9.03033C15.6103 9.17098 15.8011 9.25 16 9.25H17C17.1381 9.25 17.25 9.36193 17.25 9.5V10.5C17.25 10.9142 17.5858 11.25 18 11.25H20C20.4142 11.25 20.75 10.9142 20.75 10.5V9.61803C20.75 9.43219 20.9456 9.31131 21.1118 9.39443L22.559 10.118C22.9825 10.3298 23.25 10.7626 23.25 11.2361V16.8915C23.25 17.3225 23.028 17.7231 22.6625 17.9515L21.1325 18.9078C20.966 19.0118 20.75 18.8921 20.75 18.6958V17.5C20.75 17.0858 20.4142 16.75 20 16.75H18C17.5858 16.75 17.25 17.0858 17.25 17.5V19.5C17.25 19.6381 17.1381 19.75 17 19.75H9.51462C9.43388 19.75 9.35811 19.711 9.31118 19.6453L7.1103 16.5641C6.96952 16.367 6.74221 16.25 6.5 16.25H5C4.86193 16.25 4.75 16.1381 4.75 16V9C4.75 8.86193 4.86193 8.75 5 8.75H6.5Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeOpacity="1"
      />
      <line
        x1="1.75"
        y1="12.25"
        x2="4.25"
        y2="12.25"
        stroke={fill}
        strokeOpacity="1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="1.75"
        y1="8.75"
        x2="1.75"
        y2="16.25"
        stroke={fill}
        strokeOpacity="1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="11.5"
        y1="5.25"
        x2="11.5"
        y2="6.75"
        stroke={fill}
        strokeOpacity="1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="14.75"
        y1="4.75"
        x2="8.25"
        y2="4.75"
        stroke={fill}
        strokeOpacity="1"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
